'use strict';

import * as _ from 'lodash';

const URL = {
    isNotPrefixedWithProtocol(url: string): boolean {
        return !/^([a-z]+):\/\//.test(url);
    },

    isValidURL(url: string): boolean {
        return /^(?:[a-z]+)?:\/\/(?:www\.|(?!www))(?:(?:[a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9])|(?:[a-zA-Z0-9]))\.[^\s]{2,}/.test(url);
    },
    sanitizeSearchInput(input: string): string {
        // Sanitize user search input to prevent injection of query parameters
        return input
        .replace(/[&=?"]/g, ' ')       // Replace unsafe URL characters
        .replace(/\s+/g, ' ')          // Normalize whitespace
        .trim()                        // Remove leading/trailing spaces
        .split(' ').toString();        // "word1,word2,word3" words seperated by comma
    },
    qrcag: {
        regexp: /^\s*(?:https?:\/\/)?(?![\p{L}0-9-]*\b(?:codeonline-gtin\.gs1\.fr)\b)[\p{L}0-9-]+(?:\.[\p{L}0-9-]+)*\.[\p{L}]{2,}(?<!\b(?:codeonline-gtin\.gs1\.fr))(?::\d+)?(?:\/[^\s?]*)?(?:\?[^\s]*)?\s*$/u,
        normalizeUrl(url: string): string {
            if (!url) return '';
            const trimmed = url.trim();
            if (/^https?:\/\//i.test(trimmed)) {
                return trimmed;
            }
            return 'https://' + trimmed;
        }
    }
};

export default URL;
